export const SUBJECTS = [
    { value: 'math', label: 'Mathematics' },
    { value: 'science', label: 'Science' },
    { value: 'english', label: 'English' },
    { value: 'history', label: 'History' },
    { value: 'geography', label: 'Geography' },
    { value: 'arts', label: 'Arts' },
    { value: 'music', label: 'Music' },
    { value: 'pe', label: 'Physical Education' },
    { value: 'computers', label: 'Computer Science' },
    { value: 'language', label: 'Foreign Language' }
];
